/** i18n del módulo CRONJOBS (español) */
export default {
  cronjobs: {
    title: "Tareas programadas (CRON)",
    subtitle:
      "Define cada cuánto se ejecuta cada tarea del servidor. Requiere el módulo CRONJOBS activo.",
    timezone: "Zona horaria",
    timezoneHelp: "Se aplica a todas las tareas de esta pantalla.",
    timezoneSaveHint:
      "La zona horaria se guarda al pulsar «Guardar esta tarea» en cualquier tarea.",
    jobEnabled: "Activa",
    frequency: "Frecuencia",
    frequencyHourly: "Cada hora (minuto 0)",
    frequencyEvery6h: "Cada 6 horas",
    frequencyDaily: "Una vez al día",
    frequencyWeeklyMon: "Cada lunes",
    frequencyCustom: "Expresión cron personalizada",
    dailyAtHour: "Hora del día (0–23)",
    cronExpression: "Expresión cron",
    cronHelp:
      "Formato: minuto hora día-mes mes día-semana (ej. 0 3 * * * = cada día a las 03:00). El servidor programa una ejecución por ocurrencia (cron-parser + temporizador).",
    cronExpressionManualHelp:
      "Escribe aquí cualquier expresión válida para pruebas (ej. 0 20 * * * = cada día a las 20:00). Al editar el texto, el modo pasa a «Personalizada».",
    targetDatabases: "Bases de datos (opcional)",
    targetDatabasesHelp:
      "Vacío = solo la base actual. Separa con comas para varias (ej. duntower, cliente1).",
    findTeuJobScopeOnlyDb:
      "Esta tarea solo sincroniza trackings en la base de datos de este cliente (la de tu sesión). Cada tenant guarda la config del CRON en su MongoDB; el servidor programa una ejecución por tenant con CRONJOBS activo.",
    saveJob: "Guardar esta tarea",
    runNow: "Ejecutar ahora",
    lastRun: "Última ejecución",
    lastRunTitle: "Última ejecución",
    lastRunInTimezone: "Hora mostrada en la zona «{tz}» (la misma que usa el programador de tareas).",
    lastRunManual: "Manual",
    lastRunNever: "Aún no se ha ejecutado (ni por cron ni con «Ejecutar ahora»).",
    lastRunOk: "Correcta",
    lastRunError: "Error",
    duration: "Duración",
    loadError: "No se pudo cargar la configuración de cron.",
    saveOk: "Configuración guardada.",
    saveError: "No se pudo guardar.",
    runOk: "Tarea ejecutada.",
    runError: "Error al ejecutar la tarea.",
    moduleInactiveHint:
      "Activa el módulo CRONJOBS en Módulos del Sistema para usar esta pantalla.",
    backupsTitle: "Copias de seguridad en el servidor",
    backupsHint:
      "Solo se listan los archivos de la base de datos actual ({db}). Cada cliente tiene su propia carpeta en el disco.",
    backupsEmpty: "No hay copias .archive.gz todavía. Ejecuta el job «Copia de seguridad de base de datos» o espera al cron.",
    backupsLoadError: "No se pudo cargar la lista de copias.",
    backupFile: "Archivo",
    backupSize: "Tamaño",
    backupDate: "Fecha",
    backupDownload: "Descargar",
    backupDownloading: "Descargando…",
    backupDownloadTokenTitle: "Descarga anónima (última copia)",
    backupDownloadTokenHint:
      "Genera un token para descargar la copia más reciente sin iniciar sesión. Quien tenga la URL puede bajar el archivo.",
    backupDownloadTokenActive: "Token activo",
    backupDownloadTokenGenerated: "Generado",
    backupDownloadTokenGenerate: "Generar token",
    backupDownloadTokenRegenerate: "Generar nuevo token",
    backupDownloadTokenRegenerateConfirm: "El token anterior dejará de funcionar.",
    backupDownloadTokenRevoke: "Revocar token",
    backupDownloadTokenRevokeConfirm: "La URL dejará de funcionar de inmediato.",
    backupDownloadTokenGenerateOk: "Token generado. Copiá la URL ahora.",
    backupDownloadTokenRevokeOk: "Token revocado.",
    backupDownloadTokenError: "No se pudo gestionar el token.",
    backupDownloadUrlLabel: "URL de descarga",
    backupDownloadTokenOnceHint: "No se volverá a mostrar completa. Al generar uno nuevo, la anterior deja de funcionar.",
    backupDownloadUrlCopied: "URL copiada al portapapeles.",
    backupDownloadUrlCopyError: "No se pudo copiar la URL.",
    backupDownloadUrlCopyManual: "Seleccioná la URL del campo y copiala manualmente (Ctrl+C / Cmd+C).",
    nextRunTitle: "Próxima ejecución programada",
    nextRunDisabled: "Tarea desactivada — sin cuenta atrás.",
    nextRunInvalid: "No se pudo calcular la próxima ejecución (revisa expresión cron y zona horaria).",
    nextRunAt: "Próxima ejecución (aprox.)",
    countdownLabel: "Falta",
    countdownImminent: "En breve",
    schedulerStatusTitle: "Programador en este proceso del servidor",
    schedulerRunning: "En marcha",
    schedulerStopped: "Detenido (sin tareas cron en memoria)",
    schedulerReferenceDb: "Base de referencia del programador",
    schedulerScheduledJobs: "Jobs programados",
    schedulerTenantsTitle: "Tenants con tareas programadas (este proceso)",
    schedulerScheduledJobsUnique: "Tipos de job distintos (cualquier tenant)",
    schedulerDiscoveryMode: {
      auto:
        "Lista de tenants: todas las bases del servidor con módulo CRONJOBS activo (usa CRONJOBS_TENANT_DATABASES en el servidor para acotar).",
      explicit:
        "Lista de tenants: solo las BD indicadas en CRONJOBS_TENANT_DATABASES (cada una debe tener CRONJOBS activo).",
    },
    schedulerNone: "ninguno",
    connState: "Conexión Mongo",
    lastScheduledEvent: "Último disparo programado (este proceso)",
    idleCloseHint:
      "Mongo puede mostrarse desconectado entre ejecuciones; el servidor reconecta al lanzar un job (se cierran conexiones inactivas tras un tiempo sin tráfico).",
    activityLogTitle: "Registro de actividad (esta página)",
    activityLogHint:
      "Acciones manuales y ejecuciones detectadas (sondeo cada 30s). No sustituye los logs del servidor.",
    activityLogClear: "Vaciar",
    logPageLoaded: "Página cargada.",
    logConfigLoaded: "Configuración cargada desde el servidor.",
    logJobSaved: "Tarea «{job}» guardada.",
    logManualRunOk: "Ejecución manual finalizada: «{job}» ({ms} ms).",
    logManualRunFail: "Falló la ejecución manual: «{job}».",
    logRunDetected: "Nueva ejecución detectada para «{job}» (sincronizado con el servidor).",
    logScheduledHint: "Programada",
    logManualHint: "Manual",
    customJobsTitle: "Tareas custom (Hook automations)",
    customJobsHint: "Estas tareas se vinculan desde Hook automations con disparador cron.",
    hookAutomationsLink: "Hook automations",
    customCreate: "Nueva tarea custom",
    customCreateTitle: "Nueva tarea cron custom",
    customName: "Nombre",
    customNameRequired: "Indicá un nombre",
    customDelete: "Eliminar",
    customDeleteConfirm: "¿Eliminar la tarea «{job}»?",
    customDeleteOk: "Tarea eliminada",
    customTypeBadge: "Custom",
  },
};
